module.exports = __webpack_public_path__ + "static/media/Barnas_Skog_1.8ee4db27.pdf";